var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGreyBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10471_1200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#6C757E",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8621 40.8169C46.0068 40.8169 50.1773 36.5155 50.1773 31.2095C50.1773 25.9034 46.0068 21.6021 40.8621 21.6021C35.7174 21.6021 31.5469 25.9034 31.5469 31.2095C31.5469 36.5155 35.7174 40.8169 40.8621 40.8169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8635 44.0205C33.1511 44.0292 26.899 50.4774 26.8906 58.4316C26.8906 59.3145 27.5872 60.0329 28.4432 60.0329H53.2837C54.1397 60.0329 54.8363 59.3145 54.8363 58.4316C54.8279 50.4774 48.5758 44.0292 40.8635 44.0205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10471_1200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGreyBg);
export default __webpack_public_path__ + "static/media/user-grey-bg.934975f951d0fa7a347d8838a29d9f21.svg";
export { ForwardRef as ReactComponent };